module.exports = __webpack_public_path__ + "img/hm.757e1c1a.svg";